import "../../styles/MemberProfile.css";

const ProfileCard = ({
  title,
  isEditing,
  onEdit,
  onSave,
  onCancel,
  hideActions = false,
  readOnly = false,
  children,
}) => {
  const formId = title.replace(/\s+/g, "-").toLowerCase() + "-form";

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isEditing) onSave();
  };

  return (
    <div className="profile-card-container">
      <div className="profile-card-header">
        <h3 className="profile-card-title">{title}</h3>

        {!hideActions && !readOnly && (
          <>
            {!isEditing ? (
              <button
                type="button"
                className="link-button edit-top-btn text-primary d-flex align-items-center justify-content-center"
                onClick={onEdit}
              >
                Edit
              </button>
            ) : (
              <div className="d-flex gap-2">
                <button
                  type="submit"
                  form={formId}
                  className="auth-btn-compact bg-primary text-white flex-fill"
                >
                  Save
                </button>

                <button
                  type="button"
                  onClick={onCancel}
                  className="auth-btn-compact auth-btn-secondary flex-fill"
                >
                  Cancel
                </button>
              </div>
            )}
          </>
        )}
      </div>

      <form id={formId} onSubmit={handleSubmit}>
        <div className="profile-card-content">{children}</div>
      </form>
    </div>
  );
};

export default ProfileCard;
